import React, { useEffect, useState } from 'react';

const WORDS = [
  'Non-Woven Bags', 
  'Plastic Carry Bags', 
  'Shopping Bags',
  'Glossy Gold Printed Shining Bags',
  'Customized Metallic Bags'
];

const IMAGES = [
  { url: '/images/nonwoven-dcut-2.png', label: 'Non-Woven Bags' },
  { url: '/images/nonwoven-wcut-1.png', label: 'Non-Woven W-Cut Bags' },
  { url: '/images/plastic-carry-2.png', label: 'Plastic Carry Bags' },
  { url: '/images/laminated-shop-1.png', label: 'Shopping Bags' },
  { url: '/images/glossy-gold-bag-1.jpg', label: 'Glossy Gold Printed Shining Bags' },
  { url: '/images/glossy-gold-bag-2.jpg', label: 'Glossy Gold Printed Shining Bags' },
  { url: '/images/metallic-lamination-bag-1.jpg', label: 'Customized Metallic Bags' },
  { url: '/images/metallic-lamination-bag-2.jpg', label: 'Customized Metallic Bags' },
];

export default function Hero() {
  const [wordIdx, setWordIdx] = useState(0);
  const [imgIdx, setImgIdx] = useState(0);
  const [fade, setFade] = useState(true);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => { setTimeout(() => setLoaded(true), 100); }, []);

  useEffect(() => {
    const t = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setWordIdx(i => (i + 1) % WORDS.length);
        setImgIdx(i => (i + 1) % IMAGES.length);
        setFade(true);
      }, 400);
    }, 3000);
    return () => clearInterval(t);
  }, []);

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <>
      <style>{`
        @keyframes heroFadeUp {
          from { opacity:0; transform:translateY(40px); }
          to { opacity:1; transform:translateY(0); }
        }
        @keyframes heroPulse {
          0%,100%{transform:scale(1)} 50%{transform:scale(1.035)}
        }
        @keyframes rotateGlow {
          from{transform:rotate(0deg)} to{transform:rotate(360deg)}
        }
        @keyframes shimmerText {
          0%{background-position:0% 50%} 100%{background-position:200% 50%}
        }
        @keyframes imgFadeIn { from{opacity:0;transform:scale(1.04)} to{opacity:1;transform:scale(1)} }
        .hero-img-active { animation: imgFadeIn 0.7s ease forwards; }
        .cta-primary:hover { transform:translateY(-2px)!important; box-shadow:0 20px 50px rgba(200,137,58,0.5)!important; }
        .cta-secondary:hover { background:rgba(200,137,58,0.12)!important; border-color:rgba(200,137,58,0.6)!important; }
        .stat-card:hover { background:rgba(200,137,58,0.1)!important; transform:translateY(-2px); }
        @media(max-width:900px){
          .hero-grid { grid-template-columns:1fr!important; }
          .hero-images { display:none!important; }
        }
        @media(max-width:600px){
          .hero-title { font-size:clamp(36px,10vw,52px)!important; }
          .hero-btns { flex-direction:column!important; }
          .hero-stats { grid-template-columns:1fr 1fr!important; }
          .hero-desc { font-size:16px !important; line-height:1.5 !important; }
          .hero-badge { font-size:14px !important; padding:8px 16px !important; }
        }
        @media(max-width:480px){
          .hero-title { font-size:clamp(32px,12vw,48px)!important; }
          .hero-btns { gap:12px !important; }
          .hero-stats { grid-template-columns:1fr !important; gap:16px !important; }
        }
      `}</style>

      <section id="home" style={s.section}>
        {/* Background layers */}
        <div style={s.bgGrain} />
        <div style={s.bgGlow1} />
        <div style={s.bgGlow2} />
        <div style={s.bgGrid} />

        <div style={s.container}>
          <div className="hero-grid" style={s.grid}>

            {/* LEFT CONTENT */}
            <div style={{ ...s.content, opacity: loaded ? 1 : 0, transform: loaded ? 'none' : 'translateY(30px)', transition: 'all 1s ease 0.1s' }}>

              {/* Badge */}
              <div className="hero-badge" style={s.badge}>
                <span style={s.badgeDot} />
                Hyderabad's #1 Bag Manufacturer · Since 2009
              </div>

              {/* Title */}
              <h1 className="hero-title" style={s.title}>
                <span style={s.titleLine1}>We Print</span>
                <span style={s.titleLine1}>Premium</span>
                <span style={{
                  ...s.wordCycle,
                  opacity: fade ? 1 : 0,
                  transform: fade ? 'translateY(0)' : 'translateY(10px)',
                  transition: 'all 0.4s ease',
                }}>
                  {WORDS[wordIdx]}
                </span>
              </h1>

              <p className="hero-desc" style={s.desc}>
                Factory-direct manufacturing of non-woven bags and plastic carry bags — customised
                printed with your brand logo across the world.
              </p>

              {/* CTAs */}
              <div className="hero-btns" style={s.btns}>
                <button className="cta-primary" style={s.ctaPrimary} onClick={() => scrollTo('contact')}>
                  📞 Call Us Now
                </button>
                <button className="cta-secondary" style={s.ctaSecondary} onClick={() => scrollTo('products')}>
                  Explore Products
                  <span style={{ marginLeft: 8 }}>→</span>
                </button>
              </div>

              {/* Stats */}
              <div className="hero-stats" style={s.stats}>
                {[['5000+', 'Happy Clients'], ['1Cr+', 'Bags Printed'], ['15+', 'Yrs Experience'], ['Fastest', 'Delivery']].map(([n, l]) => (
                  <div key={l} className="stat-card" style={s.statCard}>
                    <span style={s.statNum}>{n}</span>
                    <span style={s.statLabel}>{l}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* RIGHT IMAGES */}
            <div className="hero-images" style={s.imagesWrap}>
              {/* Main image */}
              <div style={s.mainImgFrame}>
                <div style={s.mainImgGlow} />
                <img
                  key={imgIdx}
                  className="hero-img-active"
                  src={IMAGES[imgIdx].url}
                  alt={IMAGES[imgIdx].label}
                  style={s.mainImg}
                />
                <div style={s.imgLabel}>{IMAGES[imgIdx].label}</div>
                {/* Decorative corner lines */}
                <div style={{ ...s.corner, top: -1, left: -1, borderTop: '2px solid #c8893a', borderLeft: '2px solid #c8893a' }} />
                <div style={{ ...s.corner, top: -1, right: -1, borderTop: '2px solid #c8893a', borderRight: '2px solid #c8893a' }} />
                <div style={{ ...s.corner, bottom: -1, left: -1, borderBottom: '2px solid #c8893a', borderLeft: '2px solid #c8893a' }} />
                <div style={{ ...s.corner, bottom: -1, right: -1, borderBottom: '2px solid #c8893a', borderRight: '2px solid #c8893a' }} />
              </div>

              {/* Thumbnail strip */}
              <div style={s.thumbRow}>
                {IMAGES.map((img, i) => (
                  <div key={i} style={s.thumb(i === imgIdx)} onClick={() => setImgIdx(i)}>
                    <img src={img.url} alt={img.label} style={s.thumbImg} />
                    {i === imgIdx && <div style={s.thumbActive} />}
                  </div>
                ))}
              </div>

            </div>

          </div>
        </div>

        {/* Scroll indicator */}
        <div style={s.scrollInd}>
          <div style={s.scrollLine} />
          <span style={s.scrollText}>Scroll</span>
        </div>
      </section>
    </>
  );
}

const s = {
  section: {
    position: 'relative', minHeight: '100vh', background: '#0a0a0a',
    display: 'flex', alignItems: 'center', overflow: 'hidden', paddingTop: 72,
  },
  bgGrain: {
    position: 'absolute', inset: 0, opacity: 0.04, pointerEvents: 'none',
    backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
  },
  bgGlow1: {
    position: 'absolute', top: '-10%', left: '-5%', width: 700, height: 700,
    background: 'radial-gradient(circle, rgba(200,137,58,0.12) 0%, transparent 65%)',
    pointerEvents: 'none',
  },
  bgGlow2: {
    position: 'absolute', bottom: '0%', right: '5%', width: 500, height: 500,
    background: 'radial-gradient(circle, rgba(200,137,58,0.07) 0%, transparent 65%)',
    pointerEvents: 'none',
  },
  bgGrid: {
    position: 'absolute', inset: 0, pointerEvents: 'none',
    backgroundImage: `linear-gradient(rgba(200,137,58,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(200,137,58,0.03) 1px, transparent 1px)`,
    backgroundSize: '60px 60px',
  },
  container: { maxWidth: 1280, margin: '0 auto', padding: '60px 32px', width: '100%' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 60, alignItems: 'center' },
  content: {},
  badge: {
    display: 'inline-flex', alignItems: 'center', gap: 8,
    background: 'rgba(200,137,58,0.12)', border: '1px solid rgba(200,137,58,0.3)',
    color: '#c8893a', padding: '6px 16px', borderRadius: 20,
    fontSize: 12, fontWeight: 600, letterSpacing: 0.5, marginBottom: 28,
  },
  badgeDot: {
    width: 6, height: 6, borderRadius: '50%', background: '#c8893a',
    display: 'inline-block', animation: 'heroPulse 2s infinite',
  },
  title: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 'clamp(44px,5.5vw,76px)', fontWeight: 700, lineHeight: 1.1,
    color: '#f0ede6', letterSpacing: -1, marginBottom: 24,
    display: 'flex', flexDirection: 'column', gap: 4,
  },
  titleLine1: { display: 'block' },
  wordCycle: {
    display: 'block',
    background: 'linear-gradient(90deg, #c8893a, #e8c070, #c8893a)',
    backgroundSize: '200%',
    WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
    animation: 'shimmerText 2s linear infinite',
  },
  desc: {
    fontSize: 16, color: 'rgba(240,237,230,0.6)', lineHeight: 1.8,
    maxWidth: 480, marginBottom: 36,
  },
  btns: { display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: 44 },
  ctaPrimary: {
    background: 'linear-gradient(135deg, #c8893a, #e8a84a)',
    color: '#0a0a0a', border: 'none', borderRadius: 12, padding: '16px 32px',
    fontFamily: "'Outfit', sans-serif", fontWeight: 700, fontSize: 15,
    cursor: 'pointer', letterSpacing: 0.3,
    boxShadow: '0 8px 32px rgba(200,137,58,0.4)', transition: 'all 0.25s ease',
  },
  ctaSecondary: {
    background: 'transparent', color: '#f0ede6',
    border: '1px solid rgba(240,237,230,0.25)', borderRadius: 12,
    padding: '16px 28px', fontFamily: "'Outfit', sans-serif",
    fontWeight: 500, fontSize: 15, cursor: 'pointer', transition: 'all 0.25s ease',
  },
  stats: { display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10 },
  statCard: {
    background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(200,137,58,0.15)',
    borderRadius: 12, padding: '14px 12px', textAlign: 'center',
    transition: 'all 0.25s ease', cursor: 'default',
  },
  statNum: {
    display: 'block', fontFamily: "'Cormorant Garamond', serif",
    fontSize: 28, fontWeight: 700, color: '#c8893a', lineHeight: 1,
  },
  statLabel: {
    display: 'block', fontSize: 11, color: 'rgba(240,237,230,0.5)',
    letterSpacing: 0.5, marginTop: 4, fontWeight: 500,
  },
  imagesWrap: { position: 'relative' },
  mainImgFrame: {
    position: 'relative', borderRadius: 20, overflow: 'hidden',
    boxShadow: '0 32px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(200,137,58,0.1)',
  },
  mainImgGlow: {
    position: 'absolute', inset: 0,
    background: 'linear-gradient(to bottom, transparent 60%, rgba(10,10,10,0.8))',
    zIndex: 1, pointerEvents: 'none',
  },
  mainImg: { width: '100%', height: 460, objectFit: 'cover', display: 'block' },
  imgLabel: {
    position: 'absolute', bottom: 18, left: 20, zIndex: 2,
    fontFamily: "'Outfit', sans-serif", fontSize: 13, fontWeight: 600,
    color: '#f0ede6', letterSpacing: 1,
    background: 'rgba(200,137,58,0.85)', padding: '5px 12px', borderRadius: 6,
  },
  corner: { position: 'absolute', width: 20, height: 20 },
  thumbRow: { display: 'flex', gap: 10, marginTop: 12 },
  thumb: (active) => ({
    flex: 1, borderRadius: 10, overflow: 'hidden', cursor: 'pointer',
    border: `2px solid ${active ? '#c8893a' : 'transparent'}`,
    transition: 'all 0.25s ease', position: 'relative',
    opacity: active ? 1 : 0.5,
  }),
  thumbImg: { width: '100%', height: 70, objectFit: 'cover', display: 'block' },
  thumbActive: {
    position: 'absolute', bottom: 0, left: 0, right: 0, height: 3,
    background: '#c8893a',
  },
  floatCard: {
    position: 'absolute', top: 24, right: -18,
    background: 'rgba(10,10,10,0.92)', border: '1px solid rgba(200,137,58,0.3)',
    borderRadius: 14, padding: '12px 16px',
    boxShadow: '0 16px 40px rgba(0,0,0,0.5)',
    backdropFilter: 'blur(12px)',
  },
  floatCardInner: { display: 'flex', alignItems: 'center', gap: 10 },
  floatStrong: { fontSize: 13, fontWeight: 700, color: '#f0ede6' },
  floatSmall: { fontSize: 11, color: 'rgba(240,237,230,0.5)' },
  scrollInd: {
    position: 'absolute', bottom: 32, left: '50%', transform: 'translateX(-50%)',
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
  },
  scrollLine: {
    width: 1, height: 40,
    background: 'linear-gradient(to bottom, #c8893a, transparent)',
    animation: 'heroPulse 2s ease-in-out infinite',
  },
  scrollText: { fontSize: 10, letterSpacing: 3, color: 'rgba(240,237,230,0.3)', fontWeight: 600 },
};
